export const GET_COMBO_STORE = "GET_COMBO_STORE";
export const GET_COMBO_STORE_SUCCESS = "GET_COMBO_STORE_SUCCESS";
export const GET_COMBO_STORE_FAILURE = "GET_COMBO_STORE_FAILURE";
